import React, { useState, useEffect, useRef } from 'react';




const ZPOCSpeech = () => {
  const [chunksList, setChunksList] = useState([]);


  const audioStreamRef = useRef(null);
  const mediaRecorderRef = useRef(null);
  const [isRecording, setIsRecording] = useState(false);

  const startRecording = async () => {
    console.log("startRecording().................")
    setIsRecording(true);
    try {
      audioStreamRef.current = await navigator.mediaDevices.getUserMedia({ audio: true });
      mediaRecorderRef.current = new MediaRecorder(audioStreamRef.current);

      // Event handler for data available
      mediaRecorderRef.current.ondataavailable = (event) => {
        if (event.data.size > 0) {
          const recordedBlob = new Blob([event.data], { type: 'audio/wav' });
          setChunksList((prevChunks) => [...prevChunks, event.data]);
          // Do something with the recorded audio blob, e.g., save it or play it
          console.log("recordedBlob: ", recordedBlob)
        }
      };

      mediaRecorderRef.current.start();
    } catch (error) {
      console.error('Error accessing microphone:', error);
    }
  };

  const stopRecording = () => {
    console.log("stopRecording().................")
    setIsRecording(false);
    if (mediaRecorderRef.current) {
      mediaRecorderRef.current.stop();
      audioStreamRef.current.getTracks().forEach((track) => track.stop());
      console.log("stopRecording() DONE")
    }
  };

  const convertRecording = (eventType) => {
    console.log("convertRecording() isRecording:", isRecording,"   eventType:",eventType)
    //eventType BUTTON,TRIGGER
    stopRecording();
    const timeoutId = setTimeout(() => {
      console.log('Delayed action completed!');
      var cList = chunksList;
      console.log("NOT RECORDING cList: ", cList);
    }, 5000);
    
  };

  return (
    <div>
      <button onClick={startRecording}>Start Recording</button>
      <button onClick={stopRecording}>Stop Recording</button>

      <button onClick={()=>convertRecording('BUTTON')}>ConvertRecording</button>
      {/* You can add other components or controls for your audio recording functionality here */}
    </div>
  );
};

export default ZPOCSpeech;
